import { render } from "./ColSec.vue?vue&type=template&id=0991e55f"
import script from "./ColSec.vue?vue&type=script&lang=js"
export * from "./ColSec.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__